var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _c("app-section", [_c("app-title", [_vm._v(_vm._s(_vm.status))])], 1),
      _vm.error
        ? _c("app-section", [_c("app-text", [_vm._v(_vm._s(_vm.error))])], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }